import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Redirect = ({ page }) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(page);
  }, [navigate, page]);

  return (<>...</>);
};

export default Redirect;